import { render, staticRenderFns } from "./welcomepageinhome.vue?vue&type=template&id=71ebd56f&"
import script from "./welcomepageinhome.vue?vue&type=script&lang=js&"
export * from "./welcomepageinhome.vue?vue&type=script&lang=js&"
import style0 from "./welcomepageinhome.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports